<div class="char-counter" [class.limit-reached]="Value >= MaxLength">
    {{ Value + '/' + MaxLength }}
</div>